<template>
    <div class="reply-wrapper">
        <title-bar class="reply_bar" title="评论">
            <div class="reply_cancel" slot="left" @touchstart="cancel">取消</div>
            <div slot="right" @touchstart="confirm">提交</div>
        </title-bar>
        <textarea v-model="reply" placeholder="请输入内容" class="field-core" wrap="soft" resize="none"></textarea>
    </div>
</template>
<style lang="scss" scoped>
.reply-wrapper{
    background-color: white;
    width: 100vw;
    height: 100%;
    padding-top: 2.35rem;
    box-sizing: border-box;
    .reply_bar{
        position: absolute;
        left:0;
        top:0;
        z-index: 111;
        .reply_cancel{
            position: absolute;
            left: 0.7rem;
            top: 50%;
            transform: translate(0,-50%);
        }
    }
    .field-core {
        width: 16.25rem;
        height: 80%;
        padding: 1rem 1.25rem;
        overflow: hidden;
        font-size: .7rem;
        font-weight:400;
        line-height:1.2rem;
    }
}
</style>

<script>
import titleBar from "@/components/layout/TitleBar"
export default {
    name: 'Reply',
    components:{
        titleBar
    },
    props:{
        focus:false
    },
    data() {
        return{
            reply: ''
        }
    },
    watch:{
        focus(newval){
            if(newval){
                this.autoFocus();
            }
        }
    },
    methods:{
        autoFocus(){
            setTimeout(()=>{
                let area = document.querySelector('.field-core');
                area.focus();
            },300)
        },
        cancel(){

            if(isWebview){
                Keyboard.hide()
            }

            this.$emit('cancel');
            this.reply = '';
            event.cancelBubble = true;
        },
        confirm(){
            this.$emit('confirm',this.reply);
            this.reply = '';
        }
    }
}
</script>

